// NHÓM 1 THAO TÁC XÂY KÊNH (07/10/2026, người dùng duyệt): THEO DÕI / ĐĂNG KÝ trên 5 mạng + CHIA SẺ / ĐĂNG LẠI.
//  · facebook/theo_doi, x/theo_doi, tiktok/theo_doi, youtube/dang_ky, reddit/tham_gia_cong_dong: có địa chỉ (Trang / hồ sơ / kênh / cộng đồng) → làm đúng địa chỉ đó;
//    ĐỂ TRỐNG → bot TỰ TÌM bài / video mới theo từ khoá của kịch bản (bước Tìm / sản phẩm / mục tiêu — tu-dung.ts BienTheTuTim) và theo dõi TÁC GIẢ của chúng
//    (Reddit: tham gia CỘNG ĐỒNG của bài), bỏ tác giả là chính nick, bỏ trùng, bỏ người đã theo dõi (sổ cái + nút trạng thái trên trang), có sản phẩm/mục tiêu
//    thì AI chấm bài liên quan trước. Đã theo dõi rồi → KHÔNG bấm (bấm lần hai = BỎ theo dõi). Hạn mức RIÊNG mỗi ngày "theo_doi" (mặc định 10 — han-muc-ngay.ts).
//  · facebook/chia_se_bai: chia sẻ MỘT bài lên trang cá nhân (tuỳ chọn kèm lời AI soạn sau khi đọc bài); để trống địa chỉ → tự tìm bài theo từ khoá.
//    tiktok/dang_lai: Repost MỘT video (chốt đúng mã video trước khi bấm). Hạn mức riêng "chia_se" (mặc định 5). X đã có x/dang_lai.
// Mọi bước bấm đều rủi ro cao (cổng duyệt), idempotent unsafe (sổ cái ghi NGAY khi bấm), có hậu kiểm. Không nấc "model" ở nút bật/tắt (đoán sai = bỏ theo dõi).
//
// ĐỐI CHIẾU KHẢO SÁT THẬT 04/10/2026 (khao-sat-9333-0410.json Facebook / khao-sat-9334-0410.json YouTube·X·TikTok·Reddit, chỉ đọc DOM):
//  ĐÃ ĐO: Facebook — nút div[role=button] CHỮ "Theo dõi" trong h3 tên tác giả của bài (tim_bai #110, bang_tin_nhom #176); nút Chia sẻ của bài
//         div[role=button][aria-label="Gửi nội dung này cho bạn bè hoặc đăng lên trang cá nhân của bạn."] (bai_minh_binh_luan #55, bang_tin_nhom #192); hộp
//         "Chia sẻ" (div[role=dialog] + h2 "Chia sẻ") có ô Lexical role=textbox KHÔNG nhãn (menu_chia_se #22) và nút aria-label "Chia sẻ ngay" (#25) — trong
//         hộp còn các nút "Gửi cho <tên> qua Messenger" (KHÔNG bao giờ bấm).
//         X — hồ sơ người khác: [data-testid=placementTracking] > button[data-testid="<số>-follow"] aria-label "Theo dõi @<handle>" (trang_ca_nhan #43-#44);
//         đã theo dõi = button[data-testid="<số>-unfollow"] aria-label "Đang theo dõi @<handle>" (bai_tu_bang_tin #323, ô người dùng).
//         TikTok — dấu + Theo dõi trên ảnh đại diện tác giả của video: button[data-e2e="feed-follow"] (de_xuat #92, #129); nút Chia sẻ của video
//         div[role=button][data-e2e="share-icon"] aria-label "Share video …" (de_xuat #105).
//         YouTube — trang kênh: yt-page-header-view-model … button[aria-label="Đăng ký <tên kênh>."] (kenh #173); trang video: #owner #subscribe-button
//         button[aria-label^="Đăng ký"] (video #100).
//         Reddit — trang cộng đồng: shreddit-subreddit-header-buttons button.button-primary chữ "Join" (cong_dong #80).
//  CHƯA KIỂM TRÊN TRANG THẬT (ghi ngay tại hằng — danh sách đầy đủ trong báo cáo bàn giao):
//    FB nút "Theo dõi"/"Đang theo dõi" ở ĐẦU Trang / trang cá nhân; FB nút "Theo dõi" trong bài BIẾN MẤT sau khi bấm; FB hộp Chia sẻ đóng lại sau "Chia sẻ ngay";
//    X nút unfollow ở ĐẦU hồ sơ (đã đo ở ô người dùng, suy ra cho đầu hồ sơ); TikTok nút Follow / Following trên HỒ SƠ (khảo sát hồ sơ TikTok bị CAPTCHA);
//    TikTok dấu + biến mất sau khi bấm; TikTok mục "Repost" trong bảng chia sẻ + dấu đã đăng lại; YouTube trạng thái "Đã đăng ký" (aria-label "Hủy đăng ký…");
//    Reddit nút "Joined" sau khi tham gia; liên kết hồ sơ tác giả a[data-e2e="search-card-user-link"] (TikTok) / ytd-channel-name a (YouTube) có href.
import type { KhoiMau } from "./tu-dung";
import { POST_LIST_SPEC as FB_POST_LIST_SPEC } from "./fb-khoi";
import { POST_LIST_SPEC as X_POST_LIST_SPEC } from "./x-khoi";
import { TT_NICK_SPEC, VIDEO_LIST_SPEC as TT_VIDEO_LIST_SPEC } from "./tt-khoi";
import { VIDEO_LIST_SPEC as YT_VIDEO_LIST_SPEC } from "./yt-khoi";
import { POST_LIST_SPEC as RD_POST_LIST_SPEC } from "./reddit-khoi";

// Từ khoá tự tìm (máy điền lúc lắp) + câu "không có việc" chung.
const KHONG_AI = (viec: string, ai: string) => `Không tìm được ${ai} phù hợp để ${viec} lúc này (không có từ khoá/sản phẩm/mục tiêu để tìm, hoặc ${ai} tìm được đều là của chính nick / đã ${viec} / không liên quan) — không ${viec} bừa`;
const TS_SO = (ten: string, moTa: string, max = 5) => ({ ten, moTa, kieu: "so" as const, macDinh: "1", min: 1, max });

// ===================== FACEBOOK — THEO DÕI =====================
// CHƯA KIỂM TRÊN TRANG THẬT: nút ở ĐẦU Trang / trang cá nhân (nhãn aria hoặc chữ "Theo dõi"/"Follow"; đã theo dõi "Đang theo dõi"/"Following").
const FB_NUT_THEO_DOI_TRANG = { describe: "nút Theo dõi ở đầu Trang / trang cá nhân đang mở (chỉ khi CHƯA theo dõi)", ladder: [
  { t: "xpath", xpath: '(//div[@role="main"]//div[@role="button"][@aria-label="Theo dõi" or @aria-label="Follow"])[1]' },
  { t: "xpath", xpath: '(//div[@role="main"]//div[@role="button"][normalize-space()="Theo dõi" or normalize-space()="Follow"])[1]' },
] };
const FB_DA_THEO_DOI_TRANG = { describe: "nút 'Đang theo dõi' ở đầu Trang / trang cá nhân (đã theo dõi)", ladder: [
  { t: "xpath", xpath: '(//div[@role="main"]//div[@role="button"][@aria-label="Đang theo dõi" or @aria-label="Following" or normalize-space()="Đang theo dõi" or normalize-space()="Following"])[1]' },
] };
// ĐÃ ĐO (tim_bai #110): trong bài, h3 tên tác giả chứa div[role=button] CHỮ "Theo dõi" (tác giả nick chưa theo dõi). Nấc chữ khớp TRỌN chữ trong mục.
const FB_NUT_THEO_DOI_BAI = { describe: "nút Theo dõi cạnh tên tác giả trong bài này", within: "item", ladder: [
  { t: "text", text: "Theo dõi", tag: "div", exact: true },
  { t: "text", text: "Follow", tag: "div", exact: true },
] };
const FB_BAI_THEO_DOI_SPEC = {
  ...FB_POST_LIST_SPEC,
  list: { ...FB_POST_LIST_SPEC.list, describe: "bài viết kết quả tìm kiếm Facebook có nút Theo dõi tác giả" },
  fields: {
    tac_gia: FB_POST_LIST_SPEC.fields.tac_gia,
    tac_gia_url: FB_POST_LIST_SPEC.fields.tac_gia_url,
    noi_dung: FB_POST_LIST_SPEC.fields.noi_dung,
    anh_url: FB_POST_LIST_SPEC.fields.anh_url,
    nut_theo_doi: { sel: 'h2 div[role="button"], h3 div[role="button"], h4 div[role="button"]', attr: "text", regex: "^(Theo dõi|Follow)$" },
  },
  item_key: ["tac_gia_url", "tac_gia"],
};
const FB_DK_TT = "len(trim(tk_theo_doi_fb)) > 0";
const FB_THEO_DOI_TU_TIM = {
  thamSo: "trang_url", chung: "fb_theo_doi",
  yamlTim: `  - id: tk_theo_doi_fb
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_theo_doi_fb

  - id: tim_bai_theo_doi_fb
    when: "${FB_DK_TT}"
    on: web
    do: "tìm bài viết theo từ khoá {{tk_theo_doi_fb}} để tìm người / Trang đáng theo dõi"
    expect: "url chứa /search/posts"

  - id: lay_bai_theo_doi_fb
    when: "${FB_DK_TT}"
    on: web
    extract: "bài viết kết quả tìm kiếm có nút Theo dõi tác giả: tac_gia, tac_gia_url, noi_dung, nut_theo_doi"
    into: ds_theo_doi_fb

  - id: loc_theo_doi_fb
    when: "${FB_DK_TT}"
    filter: "item.nut_theo_doi and len(str(item.tac_gia)) > 0"
    into: ds_theo_doi_fb`,
  yamlSteps: `  - id: chon_theo_doi_fb
    when: "${FB_DK_TT}"
    filter: "item.id not in ledger.da_theo_doi"
    into: ds_theo_doi_fb

  - id: theo_doi_fb_tu_tim
    for_each: ds_theo_doi_fb
    max_items: {{ts.so_nguoi}}
    when: "${FB_DK_TT} and len(ds_theo_doi_fb) > 0"
    ly_do_bo_qua: "${KHONG_AI("theo dõi", "người / Trang")}"
    on: web
    do: "bấm Theo dõi cạnh tên {{item.tac_gia}} trong bài này"
    expect: "nút Theo dõi của tác giả biến mất"
    risk: high
    idempotent: unsafe
    timeout: 30s
    on_item_error: skip
    ledger: da_theo_doi`,
  learned: {
    tim_bai_theo_doi_fb: { actions: [{ kind: "navigate", url: "{{goc}}search/posts?q={{ts_url.tu_khoa_tu_tim}}" }] },
    lay_bai_theo_doi_fb: { extract_spec: FB_BAI_THEO_DOI_SPEC, ghi_khi_rong: "không tìm thấy bài nào theo từ khoá — không có ai để theo dõi" },
    loc_theo_doi_fb: { ly_do_bo: "tác giả không có nút Theo dõi (đã theo dõi / là bạn bè / của chính nick) hoặc không đọc được tên" },
    chon_theo_doi_fb: { ly_do_bo: "nick đã theo dõi người / Trang này ở lần chạy trước (sổ cái)" },
    // CHƯA KIỂM TRÊN TRANG THẬT: sau khi bấm, nút "Theo dõi" trong bài biến mất / đổi chữ.
    theo_doi_fb_tu_tim: { actions: [{ kind: "click", target: FB_NUT_THEO_DOI_BAI }], postcondition: [{ t: "locator_gone", target: FB_NUT_THEO_DOI_BAI }], dem_ngay: "theo_doi" },
  },
  params: { so_theo_doi_fb: { type: "number", default: "{{ts.so_nguoi}}", label: "Số người / Trang theo dõi tối đa" } },
  chamPhuHop: { danhSach: "ds_theo_doi_fb", truong: "noi_dung", truocBuoc: "theo_doi_fb_tu_tim", maxItemsTu: "so_nguoi", anh: "anh_url" },
};

// ===================== X — THEO DÕI =====================
const X_NUT_THEO_DOI = { describe: "nút Theo dõi của hồ sơ đang mở (chỉ khi CHƯA theo dõi)", ladder: [
  { t: "css", sel: '[data-testid="primaryColumn"] [data-testid="placementTracking"] button[data-testid$="-follow"]' },
  { t: "xpath", xpath: '(//*[@data-testid="primaryColumn"]//*[@data-testid="placementTracking"]//button[substring(@data-testid, string-length(@data-testid) - 6) = "-follow"])[1]' },
] };
// Đã đo ở ô người dùng (bai_tu_bang_tin #323): "<số>-unfollow" / "Đang theo dõi @…" — CHƯA KIỂM ở ĐẦU hồ sơ (suy ra cùng cặp follow/unfollow).
const X_DA_THEO_DOI = { describe: "nút 'Đang theo dõi' của hồ sơ (unfollow — đã theo dõi)", ladder: [
  { t: "css", sel: '[data-testid="primaryColumn"] [data-testid="placementTracking"] button[data-testid$="-unfollow"]' },
] };
const X_THEO_DOI_HOC = (url: string) => ({
  actions: [{ kind: "navigate", url }, { kind: "click", target: X_NUT_THEO_DOI }],
  bo_qua_khi: [{ khi: { t: "locator_visible", target: X_DA_THEO_DOI }, ghi: "đã theo dõi tài khoản này từ trước — không bấm (bấm lần hai là bỏ theo dõi)" }],
  postcondition: [{ t: "locator_visible", target: X_DA_THEO_DOI }],
  dem_ngay: "theo_doi",
});
const X_BAI_THEO_DOI_SPEC = {
  ...X_POST_LIST_SPEC,
  list: { ...X_POST_LIST_SPEC.list, describe: "bài kết quả tìm kiếm X (để theo dõi tác giả)" },
  fields: {
    ...X_POST_LIST_SPEC.fields,
    // href tuyệt đối của liên kết tên tác giả (User-Name có 3 liên kết "/…": tên, @handle, giờ đăng — lấy cái ĐẦU = tên) → mở hồ sơ.
    ho_so_url: { sel: '[data-testid="User-Name"] a[href^="/"]', attr: "href" },
  },
  item_key: "ho_so_url",
};
const X_DK_TT = "len(trim(tk_theo_doi_x)) > 0";
const X_THEO_DOI_TU_TIM = {
  thamSo: "tai_khoan_url", chung: "x_theo_doi",
  yamlTim: `  - id: tk_theo_doi_x
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_theo_doi_x

  - id: tim_bai_theo_doi_x
    when: "${X_DK_TT}"
    on: web
    do: "tìm bài X mới nhất theo từ khoá {{tk_theo_doi_x}} để tìm người đáng theo dõi"
    expect: "url chứa /search"

  - id: lay_nick_theo_doi_x
    when: "${X_DK_TT}"
    on: web
    extract: "nick đang đăng nhập (link Hồ sơ ở thanh bên)"
    into: nick_theo_doi_x

  - id: lay_bai_theo_doi_x
    when: "${X_DK_TT}"
    on: web
    extract: "bài kết quả tìm kiếm: tac_gia, ho_so_url, noi_dung, quang_cao"
    into: ds_theo_doi_x

  - id: loc_theo_doi_x
    when: "${X_DK_TT}"
    filter: "len(str(nick_theo_doi_x)) > 1 and len(str(item.ho_so_url)) > 0 and not item.quang_cao and lower(str(item.tac_gia)) != lower(str(nick_theo_doi_x))"
    into: ds_theo_doi_x`,
  yamlSteps: `  - id: chon_theo_doi_x
    when: "${X_DK_TT}"
    filter: "item.ho_so_url not in ledger.da_theo_doi"
    into: ds_theo_doi_x

  - id: theo_doi_x_tu_tim
    for_each: ds_theo_doi_x
    max_items: {{ts.so_nguoi}}
    when: "${X_DK_TT} and len(ds_theo_doi_x) > 0"
    ly_do_bo_qua: "${KHONG_AI("theo dõi", "người")}"
    on: web
    do: "mở hồ sơ {{item.ho_so_url}} rồi bấm Theo dõi"
    expect: "nút chuyển sang Đang theo dõi"
    risk: high
    idempotent: unsafe
    timeout: 45s
    on_item_error: skip
    ledger: da_theo_doi`,
  learned: {
    tim_bai_theo_doi_x: { actions: [{ kind: "navigate", url: "{{goc}}search?q={{ts_url.tu_khoa_tu_tim}}&f=live" }] },
    lay_nick_theo_doi_x: { extract_spec: { mode: "single", target: { describe: "link Hồ sơ của nick đang đăng nhập (không có = chưa đăng nhập → dừng)", ladder: [{ t: "css", sel: 'a[data-testid="AppTabBar_Profile_Link"]' }] }, attr: "href", regex: "(/[A-Za-z0-9_]+)/?$" } },
    lay_bai_theo_doi_x: { extract_spec: X_BAI_THEO_DOI_SPEC, ghi_khi_rong: "không tìm thấy bài nào theo từ khoá — không có ai để theo dõi" },
    loc_theo_doi_x: { ly_do_bo: "bài quảng cáo, không đọc được hồ sơ tác giả, hoặc bài của CHÍNH nick" },
    chon_theo_doi_x: { ly_do_bo: "nick đã theo dõi người này ở lần chạy trước (sổ cái)" },
    theo_doi_x_tu_tim: X_THEO_DOI_HOC("{{item.ho_so_url}}"),
  },
  params: { so_theo_doi_x: { type: "number", default: "{{ts.so_nguoi}}", label: "Số người theo dõi tối đa" } },
  chamPhuHop: { danhSach: "ds_theo_doi_x", truong: "noi_dung", truocBuoc: "theo_doi_x_tu_tim", maxItemsTu: "so_nguoi", anh: "anh_url" },
};

// ===================== TIKTOK — THEO DÕI =====================
// CHƯA KIỂM TRÊN TRANG THẬT (khảo sát hồ sơ TikTok 04/10 bị CAPTCHA): nút Follow / Following trên HỒ SƠ.
const TT_NUT_FOLLOW_HO_SO = { describe: "nút Follow của hồ sơ TikTok đang mở (chỉ khi CHƯA follow)", ladder: [
  { t: "css", sel: 'button[data-e2e="follow-button"]', text: "Follow" },
  { t: "xpath", xpath: '(//button[normalize-space()="Follow" or normalize-space()="Theo dõi" or normalize-space()="Follow back" or normalize-space()="Follow lại"])[1]' },
] };
const TT_DA_FOLLOW_HO_SO = { describe: "nút 'Following' / 'Bạn bè' của hồ sơ (đã follow)", ladder: [
  { t: "xpath", xpath: '(//button[normalize-space()="Following" or normalize-space()="Đang Follow" or normalize-space()="Đang theo dõi" or normalize-space()="Friends" or normalize-space()="Bạn bè"])[1]' },
] };
// ĐÃ ĐO (de_xuat #92): dấu + trên ảnh đại diện tác giả của video. CHƯA KIỂM: dấu + biến mất sau khi bấm.
const TT_NUT_FOLLOW_VIDEO = { describe: "dấu Theo dõi (+) trên ảnh đại diện tác giả của video đang xem", ladder: [{ t: "xpath", xpath: '(//*[@data-e2e="feed-follow"])[1]' }] };
const TT_CHOT_VIDEO = (bienUrl: string) => ({ cond: { t: "url_contains", s: `{{ ma_video(${bienUrl}) }}` }, ly_do: "trang đã tự chuyển sang video khác — không bấm (tránh theo dõi / đăng lại nhầm video khác)" });
const TT_VIDEO_THEO_DOI_SPEC = {
  ...TT_VIDEO_LIST_SPEC,
  list: { ...TT_VIDEO_LIST_SPEC.list, describe: "video kết quả tìm kiếm TikTok (để theo dõi tác giả)" },
  fields: { ...TT_VIDEO_LIST_SPEC.fields, ho_so_url: { sel: 'a[data-e2e="search-card-user-link"]', attr: "href" } },
  item_key: "ho_so_url",
};
const TT_DK_TT = "len(trim(tk_theo_doi_tt)) > 0";
const TT_THEO_DOI_TU_TIM = {
  thamSo: "tai_khoan_url", chung: "tt_theo_doi",
  yamlTim: `  - id: tk_theo_doi_tt
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_theo_doi_tt

  - id: tim_video_theo_doi_tt
    when: "${TT_DK_TT}"
    on: web
    do: "tìm video TikTok theo từ khoá {{tk_theo_doi_tt}} để tìm người đáng theo dõi"
    expect: "url chứa /search"

  - id: lay_nick_theo_doi_tt
    when: "${TT_DK_TT}"
    on: web
    extract: "nick TikTok đang đăng nhập (liên kết Hồ sơ)"
    into: nick_theo_doi_tt
    optional: true

  - id: lay_video_theo_doi_tt
    when: "${TT_DK_TT}"
    on: web
    extract: "danh sách video: tac_gia, ho_so_url, mo_ta, lien_ket"
    into: ds_theo_doi_tt

  - id: loc_theo_doi_tt
    when: "${TT_DK_TT}"
    filter: "len(str(item.lien_ket)) > 0 and len(str(item.ho_so_url)) > 0 and not (len(str(nick_theo_doi_tt)) > 0 and lower(str(item.tac_gia)) == lower(str(nick_theo_doi_tt)))"
    into: ds_theo_doi_tt`,
  yamlSteps: `  - id: chon_theo_doi_tt
    when: "${TT_DK_TT}"
    filter: "item.ho_so_url not in ledger.da_theo_doi"
    into: ds_theo_doi_tt

  - id: theo_doi_tt_tu_tim
    for_each: ds_theo_doi_tt
    max_items: {{ts.so_nguoi}}
    when: "${TT_DK_TT} and len(ds_theo_doi_tt) > 0"
    ly_do_bo_qua: "${KHONG_AI("theo dõi", "người")}"
    on: web
    do: "mở video {{item.lien_ket}} rồi bấm dấu + Theo dõi trên ảnh đại diện của {{item.tac_gia}}"
    expect: "dấu + Theo dõi biến mất"
    risk: high
    idempotent: unsafe
    timeout: 45s
    on_item_error: skip
    ledger: da_theo_doi`,
  learned: {
    tim_video_theo_doi_tt: { actions: [{ kind: "navigate", url: "{{goc}}search/video?q={{ts_url.tu_khoa_tu_tim}}&t=1" }] },
    lay_nick_theo_doi_tt: { extract_spec: TT_NICK_SPEC },
    lay_video_theo_doi_tt: { extract_spec: TT_VIDEO_THEO_DOI_SPEC, ghi_khi_rong: "không tìm thấy video nào theo từ khoá — không có ai để theo dõi" },
    loc_theo_doi_tt: { ly_do_bo: "video không có liên kết / hồ sơ tác giả, hoặc là video của CHÍNH nick" },
    chon_theo_doi_tt: { ly_do_bo: "nick đã theo dõi người này ở lần chạy trước (sổ cái)" },
    theo_doi_tt_tu_tim: {
      actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }, { kind: "click", target: TT_NUT_FOLLOW_VIDEO, chot: TT_CHOT_VIDEO("item.lien_ket") }],
      postcondition: [{ t: "url_contains", s: "{{ ma_video(item.lien_ket) }}" }, { t: "locator_gone", target: TT_NUT_FOLLOW_VIDEO }],
      dem_ngay: "theo_doi",
    },
  },
  params: { so_theo_doi_tt: { type: "number", default: "{{ts.so_nguoi}}", label: "Số người theo dõi tối đa" } },
  chamPhuHop: { danhSach: "ds_theo_doi_tt", truong: "mo_ta", truocBuoc: "theo_doi_tt_tu_tim", maxItemsTu: "so_nguoi", anh: "anh_url" },
};

// ===================== YOUTUBE — ĐĂNG KÝ KÊNH =====================
const YT_NUT_DANG_KY_KENH = { describe: "nút Đăng ký kênh ở đầu trang kênh (chỉ khi CHƯA đăng ký)", ladder: [
  { t: "xpath", xpath: '(//yt-page-header-view-model//button[starts-with(@aria-label, "Đăng ký ") or starts-with(@aria-label, "Subscribe to ")])[1]' },
  { t: "xpath", xpath: '(//*[@id="page-header"]//button[starts-with(@aria-label, "Đăng ký ") or starts-with(@aria-label, "Subscribe to ")])[1]' },
] };
// CHƯA KIỂM TRÊN TRANG THẬT: trạng thái đã đăng ký (aria-label "Hủy đăng ký…"/"Unsubscribe…" hoặc chữ "Đã đăng ký"/"Subscribed").
const YT_DA_DANG_KY_KENH = { describe: "nút 'Đã đăng ký' ở đầu trang kênh (đã đăng ký)", ladder: [
  { t: "xpath", xpath: '(//yt-page-header-view-model//button[starts-with(@aria-label, "Hủy đăng ký") or starts-with(@aria-label, "Huỷ đăng ký") or starts-with(@aria-label, "Unsubscribe")] | //yt-page-header-view-model//*[normalize-space()="Đã đăng ký" or normalize-space()="Subscribed"])[1]' },
] };
const YT_DANG_KY_HOC = (url: string) => ({
  actions: [{ kind: "navigate", url }, { kind: "click", target: YT_NUT_DANG_KY_KENH }],
  bo_qua_khi: [{ khi: { t: "locator_visible", target: YT_DA_DANG_KY_KENH }, ghi: "đã đăng ký kênh này từ trước — không bấm (bấm lần hai là huỷ đăng ký)" }],
  postcondition: [{ t: "locator_visible", target: YT_DA_DANG_KY_KENH }],
  dem_ngay: "theo_doi",
});
const YT_VIDEO_DANG_KY_SPEC = {
  ...YT_VIDEO_LIST_SPEC,
  list: { ...YT_VIDEO_LIST_SPEC.list, describe: "video kết quả tìm kiếm YouTube (để đăng ký kênh)" },
  fields: { ...YT_VIDEO_LIST_SPEC.fields, kenh_url: { sel: "ytd-channel-name a", attr: "href", alt: ["#channel-name a"] } },
  item_key: "kenh_url",
};
const YT_DK_TT = "len(trim(tk_dang_ky_yt)) > 0";
const YT_DANG_KY_TU_TIM = {
  thamSo: "kenh_url", chung: "yt_dang_ky",
  yamlTim: `  - id: tk_dang_ky_yt
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_dang_ky_yt

  - id: tim_video_dang_ky_yt
    when: "${YT_DK_TT}"
    on: web
    do: "tìm video YouTube theo từ khoá {{tk_dang_ky_yt}} để tìm kênh đáng đăng ký"
    expect: "url chứa /results"

  - id: lay_video_dang_ky_yt
    when: "${YT_DK_TT}"
    on: web
    extract: "danh sách video: tieu_de, kenh, kenh_url, lien_ket"
    into: ds_dang_ky_yt

  - id: loc_dang_ky_yt
    when: "${YT_DK_TT}"
    filter: "len(str(item.kenh_url)) > 0"
    into: ds_dang_ky_yt`,
  yamlSteps: `  - id: chon_dang_ky_yt
    when: "${YT_DK_TT}"
    filter: "item.kenh_url not in ledger.da_dang_ky_kenh"
    into: ds_dang_ky_yt

  - id: dang_ky_kenh_tu_tim_yt
    for_each: ds_dang_ky_yt
    max_items: {{ts.so_kenh}}
    when: "${YT_DK_TT} and len(ds_dang_ky_yt) > 0"
    ly_do_bo_qua: "${KHONG_AI("đăng ký", "kênh")}"
    on: web
    do: "mở kênh {{item.kenh_url}} rồi bấm Đăng ký"
    expect: "nút chuyển sang Đã đăng ký"
    risk: high
    idempotent: unsafe
    timeout: 45s
    on_item_error: skip
    ledger: da_dang_ky_kenh`,
  learned: {
    tim_video_dang_ky_yt: { actions: [{ kind: "navigate", url: "{{goc}}results?search_query={{ts_url.tu_khoa_tu_tim}}" }] },
    lay_video_dang_ky_yt: { extract_spec: YT_VIDEO_DANG_KY_SPEC, ghi_khi_rong: "không tìm thấy video nào theo từ khoá — không có kênh nào để đăng ký" },
    loc_dang_ky_yt: { ly_do_bo: "không đọc được địa chỉ kênh của video (playlist / quảng cáo)" },
    chon_dang_ky_yt: { ly_do_bo: "nick đã đăng ký kênh này ở lần chạy trước (sổ cái)" },
    dang_ky_kenh_tu_tim_yt: YT_DANG_KY_HOC("{{item.kenh_url}}"),
  },
  params: { so_dang_ky_yt: { type: "number", default: "{{ts.so_kenh}}", label: "Số kênh đăng ký tối đa" } },
  chamPhuHop: { danhSach: "ds_dang_ky_yt", truong: "tieu_de", truocBuoc: "dang_ky_kenh_tu_tim_yt", maxItemsTu: "so_kenh", anh: "anh_url" },
};

// ===================== REDDIT — THAM GIA CỘNG ĐỒNG =====================
// (Theo dõi NGƯỜI trên Reddit ít dùng, trang hồ sơ chưa khảo sát → không làm; Reddit "tham gia" là cộng đồng.)
const RD_NUT_JOIN = { describe: "nút Join (tham gia) ở đầu trang cộng đồng (chỉ khi CHƯA tham gia)", ladder: [
  { t: "css", sel: "shreddit-subreddit-header-buttons button.button-primary", text: "Join" },
  { t: "css", sel: "shreddit-subreddit-header-buttons button.button-primary", text: "Tham gia" },
] };
// CHƯA KIỂM TRÊN TRANG THẬT: nút đổi chữ "Joined" / "Đã tham gia" sau khi tham gia.
const RD_DA_JOIN = { describe: "nút 'Joined' (đã tham gia cộng đồng)", ladder: [
  { t: "css", sel: "shreddit-subreddit-header-buttons button", text: "Joined" },
  { t: "css", sel: "shreddit-subreddit-header-buttons button", text: "Đã tham gia" },
] };
const RD_JOIN_HOC = (url: string) => ({
  actions: [{ kind: "navigate", url }, { kind: "click", target: RD_NUT_JOIN }],
  bo_qua_khi: [{ khi: { t: "locator_visible", target: RD_DA_JOIN }, ghi: "đã tham gia cộng đồng này từ trước — không bấm (bấm lần hai là rời cộng đồng)" }],
  postcondition: [{ t: "locator_visible", target: RD_DA_JOIN }],
  dem_ngay: "theo_doi",
});
const RD_BAI_CONG_DONG_SPEC = {
  ...RD_POST_LIST_SPEC,
  list: { ...RD_POST_LIST_SPEC.list, describe: "bài kết quả tìm Reddit (để tham gia cộng đồng)" },
  fields: { ...RD_POST_LIST_SPEC.fields, cong_dong_url: { sel: 'a[data-testid="post-title-text"], a[data-testid="post-title"]', attr: "href", regex: "^(https?://[^/]+/r/[^/?#]+)" } },
  item_key: "cong_dong_url",
};
const RD_DK_TT = "len(trim(tk_cong_dong_rd)) > 0";
const RD_CONG_DONG_TU_TIM = {
  thamSo: "cong_dong_url", chung: "rd_cong_dong",
  yamlTim: `  - id: tk_cong_dong_rd
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_cong_dong_rd

  - id: tim_bai_cong_dong_rd
    when: "${RD_DK_TT}"
    on: web
    do: "tìm bài Reddit theo từ khoá {{tk_cong_dong_rd}} để tìm cộng đồng hợp chủ đề"
    expect: "url chứa /search"

  - id: lay_bai_cong_dong_rd
    when: "${RD_DK_TT}"
    on: web
    extract: "bài kết quả tìm Reddit: tieu_de, lien_ket, cong_dong, cong_dong_url"
    into: ds_cong_dong_rd

  - id: loc_cong_dong_rd
    when: "${RD_DK_TT}"
    filter: "len(str(item.cong_dong_url)) > 0"
    into: ds_cong_dong_rd`,
  yamlSteps: `  - id: chon_cong_dong_rd
    when: "${RD_DK_TT}"
    filter: "item.cong_dong_url not in ledger.da_tham_gia_cong_dong"
    into: ds_cong_dong_rd

  - id: tham_gia_cong_dong_tu_tim_rd
    for_each: ds_cong_dong_rd
    max_items: {{ts.so_cong_dong}}
    when: "${RD_DK_TT} and len(ds_cong_dong_rd) > 0"
    ly_do_bo_qua: "${KHONG_AI("tham gia", "cộng đồng")}"
    on: web
    do: "mở cộng đồng {{item.cong_dong_url}} rồi bấm Join"
    expect: "nút chuyển sang Joined"
    risk: high
    idempotent: unsafe
    timeout: 45s
    on_item_error: skip
    ledger: da_tham_gia_cong_dong`,
  learned: {
    tim_bai_cong_dong_rd: { actions: [{ kind: "navigate", url: "{{goc}}search/?q={{ts_url.tu_khoa_tu_tim}}&sort=new" }], postcondition: [{ t: "url_contains", s: "/search" }] },
    lay_bai_cong_dong_rd: { extract_spec: RD_BAI_CONG_DONG_SPEC, ghi_khi_rong: "không tìm thấy bài nào theo từ khoá — không có cộng đồng nào để tham gia" },
    loc_cong_dong_rd: { ly_do_bo: "không đọc được cộng đồng của bài" },
    chon_cong_dong_rd: { ly_do_bo: "nick đã tham gia cộng đồng này ở lần chạy trước (sổ cái)" },
    tham_gia_cong_dong_tu_tim_rd: RD_JOIN_HOC("{{item.cong_dong_url}}/"),
  },
  params: { so_cong_dong_rd: { type: "number", default: "{{ts.so_cong_dong}}", label: "Số cộng đồng tham gia tối đa" } },
  chamPhuHop: { danhSach: "ds_cong_dong_rd", truong: "tieu_de", truocBuoc: "tham_gia_cong_dong_tu_tim_rd", maxItemsTu: "so_cong_dong" },
};

// ===================== FACEBOOK — CHIA SẺ BÀI LÊN TRANG CÁ NHÂN =====================
const FB_NUT_CHIA_SE_BAI = (trongMuc: boolean) => ({ describe: trongMuc ? "nút Chia sẻ của bài này" : "nút Chia sẻ của bài đang mở", ...(trongMuc ? { within: "item" } : { vung: "bai_dich" }), ladder: [
  { t: "css", sel: 'div[role="button"][aria-label="Gửi nội dung này cho bạn bè hoặc đăng lên trang cá nhân của bạn."]' },
  { t: "css", sel: 'div[role="button"][aria-label="Send this to friends or post it on your profile."]' },
] });
// Hộp "Chia sẻ": ô lời (Lexical KHÔNG nhãn) + "Chia sẻ ngay". Chỉ nhận ô / nút TRONG hộp có tiêu đề "Chia sẻ"/"Share" — không bấm "Gửi … qua Messenger".
const HOP_CHIA_SE = '//div[@role="dialog"][.//h2[normalize-space()="Chia sẻ" or normalize-space()="Share"]]';
const FB_O_LOI_CHIA_SE = { describe: "ô lời chia sẻ trong hộp Chia sẻ (không phải ô chat)", ladder: [
  { t: "xpath", xpath: `(${HOP_CHIA_SE}//div[@role="textbox"][@contenteditable="true"])[1]` },
] };
const FB_NUT_CHIA_SE_NGAY = { describe: "nút 'Chia sẻ ngay' trong hộp Chia sẻ (lên trang cá nhân — KHÔNG phải gửi qua Messenger)", ladder: [
  { t: "xpath", xpath: `(${HOP_CHIA_SE}//div[@role="button"][@aria-label="Chia sẻ ngay" or @aria-label="Share now"])[1]` },
  { t: "css", sel: 'div[role="dialog"] div[role="button"][aria-label="Chia sẻ ngay"]' },
] };
const FB_HOP_CHIA_SE_DONG = [{ t: "locator_gone", target: { describe: "hộp Chia sẻ còn mở (nút 'Chia sẻ ngay')", ladder: [{ t: "css", sel: 'div[role="dialog"] div[role="button"][aria-label="Chia sẻ ngay"]' }] } }];
const FB_CHIA_SE_ACTIONS = (trongMuc: boolean, loi?: string) => [
  ...(trongMuc ? [] : [{ kind: "navigate", url: "{{item.lien_ket}}" }]),
  { kind: "click", target: FB_NUT_CHIA_SE_BAI(trongMuc) },
  ...(loi ? [{ kind: "type", target: FB_O_LOI_CHIA_SE, text: loi, clear: true }] : []),
  { kind: "click", target: FB_NUT_CHIA_SE_NGAY },
];
const FB_CS_SPEC = { ...FB_POST_LIST_SPEC, list: { ...FB_POST_LIST_SPEC.list, describe: "bài viết kết quả tìm kiếm Facebook (để chia sẻ)" } };
const FB_DK_CS = "len(trim(tk_chia_se_fb)) > 0";
const SOAN_LOI_CS = (ngu: string) => `Bài Facebook sắp được chia sẻ lên trang cá nhân của bạn: ${ngu} — viết MỘT câu ngắn giới thiệu khi chia sẻ, góc nhìn: {{goc_nhin_chia_se_fb}} (không chèn liên kết, không hashtag, không giả làm tác giả bài)`;
const FB_CHIA_SE_TU_TIM = {
  thamSo: "bai_url", chung: "fb_chia_se",
  yamlTim: `  - id: tk_chia_se_fb
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_chia_se_fb

  - id: tim_bai_chia_se_fb
    when: "${FB_DK_CS}"
    on: web
    do: "tìm bài viết theo từ khoá {{tk_chia_se_fb}} để chọn bài đáng chia sẻ"
    expect: "url chứa /search/posts"

  - id: lay_bai_chia_se_fb
    when: "${FB_DK_CS}"
    on: web
    extract: "bài viết kết quả tìm kiếm: tac_gia, noi_dung, lien_ket"
    into: ds_chia_se_fb

  - id: loc_chia_se_fb
    when: "${FB_DK_CS}"
    filter: "len(str(item.noi_dung)) > 40 and not la_quang_cao(item.noi_dung)"
    into: ds_chia_se_fb`,
  yamlSteps: `  - id: chon_chia_se_fb
    when: "${FB_DK_CS}"
    filter: "item.id not in ledger.da_chia_se"
    into: ds_chia_se_fb

  - id: soan_loi_chia_se_fb_tu_tim
    for_each: ds_chia_se_fb
    max_items: 1
    when: "${FB_DK_CS} and kem_loi_chia_se_fb == 'co'"
    generate:
      input: "${SOAN_LOI_CS("{{item.noi_dung}}")}"
      guide: knowledge
      max_words: 30
    into: item.loi_chia_se

  - id: chia_se_fb_tu_tim
    for_each: ds_chia_se_fb
    max_items: 1
    when: "${FB_DK_CS} and len(ds_chia_se_fb) > 0 and kem_loi_chia_se_fb != 'co'"
    ly_do_bo_qua: "${KHONG_AI("chia sẻ", "bài")}"
    on: web
    do: "bấm Chia sẻ của bài này rồi bấm Chia sẻ ngay (lên trang cá nhân)"
    expect: "hộp Chia sẻ đóng lại"
    risk: high
    idempotent: unsafe
    timeout: 60s
    on_item_error: skip
    ledger: da_chia_se

  - id: chia_se_loi_fb_tu_tim
    for_each: ds_chia_se_fb
    max_items: 1
    when: "${FB_DK_CS} and kem_loi_chia_se_fb == 'co' and len(trim(str(item.loi_chia_se))) > 0"
    on: web
    do: "bấm Chia sẻ của bài này, gõ {{item.loi_chia_se}} rồi bấm Chia sẻ ngay"
    expect: "hộp Chia sẻ đóng lại"
    risk: high
    idempotent: unsafe
    timeout: 60s
    on_item_error: skip
    ledger: da_chia_se`,
  learned: {
    tim_bai_chia_se_fb: { actions: [{ kind: "navigate", url: "{{goc}}search/posts?q={{ts_url.tu_khoa_tu_tim}}" }] },
    lay_bai_chia_se_fb: { extract_spec: FB_CS_SPEC, ghi_khi_rong: "không tìm thấy bài nào theo từ khoá — không có gì để chia sẻ" },
    loc_chia_se_fb: { ly_do_bo: "bài quá ngắn hoặc quảng cáo / tuyển dụng" },
    chon_chia_se_fb: { ly_do_bo: "nick đã chia sẻ bài này ở lần chạy trước (sổ cái)" },
    chia_se_fb_tu_tim: { actions: FB_CHIA_SE_ACTIONS(true), postcondition: FB_HOP_CHIA_SE_DONG, dem_ngay: "chia_se" },
    chia_se_loi_fb_tu_tim: { actions: FB_CHIA_SE_ACTIONS(true, "{{item.loi_chia_se}}"), postcondition: [...FB_HOP_CHIA_SE_DONG, { t: "text_visible", text: "{{item.loi_chia_se}}" }], dem_ngay: "chia_se" },
  },
  params: {
    kem_loi_chia_se_fb: { type: "string", default: "{{ts.loi_chia_se}}", label: "Kèm lời chia sẻ AI soạn (co / khong)" },
    goc_nhin_chia_se_fb: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của lời chia sẻ" },
  },
  chamPhuHop: { danhSach: "ds_chia_se_fb", truong: "noi_dung", truocBuoc: "soan_loi_chia_se_fb_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};

// ===================== TIKTOK — ĐĂNG LẠI (REPOST) =====================
const TT_NUT_CHIA_SE = { describe: "nút Chia sẻ (mũi tên) của video đang xem", ladder: [
  { t: "xpath", xpath: '(//*[@data-e2e="share-icon"])[1]' },
  { t: "xpath", xpath: '(//*[@role="button"][starts-with(@aria-label, "Share video") or starts-with(@aria-label, "Chia sẻ video")])[1]' },
] };
// CHƯA KIỂM TRÊN TRANG THẬT: mục "Repost"/"Đăng lại" trong bảng chia sẻ (chữ khớp TRỌN — không bấm "Remove repost"/"Gỡ đăng lại") + dấu đã đăng lại.
const TT_MUC_REPOST = { describe: "mục 'Repost' (Đăng lại) trong bảng chia sẻ", ladder: [
  { t: "css", sel: '[data-e2e="share-repost"]' },
  { t: "xpath", xpath: '(//*[self::button or @role="button" or self::div or self::p or self::span][normalize-space()="Repost" or normalize-space()="Đăng lại"])[1]' },
] };
const TT_DA_REPOST = [{ t: "locator_visible", target: { describe: "dấu đã đăng lại (Reposted / Đã đăng lại)", ladder: [
  { t: "xpath", xpath: '(//*[normalize-space()="Reposted" or normalize-space()="You reposted" or normalize-space()="Đã đăng lại" or normalize-space()="Bạn đã đăng lại" or normalize-space()="Remove repost" or normalize-space()="Gỡ đăng lại"])[1]' },
] } }];
const TT_REPOST_ACTIONS = [
  { kind: "navigate", url: "{{item.lien_ket}}" },
  { kind: "click", target: TT_NUT_CHIA_SE, chot: TT_CHOT_VIDEO("item.lien_ket") },
  { kind: "click", target: TT_MUC_REPOST, chot: TT_CHOT_VIDEO("item.lien_ket") },
];
const TT_DL_SPEC = { ...TT_VIDEO_LIST_SPEC, list: { ...TT_VIDEO_LIST_SPEC.list, describe: "video kết quả tìm kiếm TikTok (để đăng lại)" } };
const TT_DK_DL = "len(trim(tk_dang_lai_tt)) > 0";
const TT_DANG_LAI_TU_TIM = {
  thamSo: "bai_url", chung: "tt_dang_lai",
  yamlTim: `  - id: tk_dang_lai_tt
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_dang_lai_tt

  - id: tim_video_dang_lai_tt
    when: "${TT_DK_DL}"
    on: web
    do: "tìm video TikTok theo từ khoá {{tk_dang_lai_tt}} để chọn video đáng đăng lại"
    expect: "url chứa /search"

  - id: lay_nick_dang_lai_tt
    when: "${TT_DK_DL}"
    on: web
    extract: "nick TikTok đang đăng nhập (liên kết Hồ sơ)"
    into: nick_dang_lai_tt
    optional: true

  - id: lay_video_dang_lai_tt
    when: "${TT_DK_DL}"
    on: web
    extract: "danh sách video: tac_gia, mo_ta, lien_ket"
    into: ds_dang_lai_tt

  - id: loc_dang_lai_tt
    when: "${TT_DK_DL}"
    filter: "len(str(item.lien_ket)) > 0 and not (len(str(nick_dang_lai_tt)) > 0 and lower(str(item.tac_gia)) == lower(str(nick_dang_lai_tt)))"
    into: ds_dang_lai_tt`,
  yamlSteps: `  - id: chon_dang_lai_tt
    when: "${TT_DK_DL}"
    filter: "item.lien_ket not in ledger.da_dang_lai_tt"
    into: ds_dang_lai_tt

  - id: dang_lai_tt_tu_tim
    for_each: ds_dang_lai_tt
    max_items: 1
    when: "${TT_DK_DL} and len(ds_dang_lai_tt) > 0"
    ly_do_bo_qua: "${KHONG_AI("đăng lại", "video")}"
    on: web
    do: "mở video {{item.lien_ket}}, bấm Chia sẻ rồi chọn Repost"
    expect: "video chuyển sang đã đăng lại"
    risk: high
    idempotent: unsafe
    timeout: 45s
    on_item_error: skip
    ledger: da_dang_lai_tt`,
  learned: {
    tim_video_dang_lai_tt: { actions: [{ kind: "navigate", url: "{{goc}}search/video?q={{ts_url.tu_khoa_tu_tim}}&t=1" }] },
    lay_nick_dang_lai_tt: { extract_spec: TT_NICK_SPEC },
    lay_video_dang_lai_tt: { extract_spec: TT_DL_SPEC, ghi_khi_rong: "không tìm thấy video nào theo từ khoá — không có gì để đăng lại" },
    loc_dang_lai_tt: { ly_do_bo: "video không có liên kết, hoặc là video của CHÍNH nick" },
    chon_dang_lai_tt: { ly_do_bo: "nick đã đăng lại video này ở lần chạy trước (sổ cái)" },
    dang_lai_tt_tu_tim: { actions: TT_REPOST_ACTIONS, postcondition: [{ t: "url_contains", s: "{{ ma_video(item.lien_ket) }}" }, ...TT_DA_REPOST], dem_ngay: "chia_se" },
  },
  chamPhuHop: { danhSach: "ds_dang_lai_tt", truong: "mo_ta", truocBuoc: "dang_lai_tt_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};

// ===================== CÁC KHỐI =====================
const MO_TA_DIA_CHI = "Không bắt buộc — để trống thì bot tự tìm theo từ khoá của kịch bản (bước Tìm / sản phẩm / mục tiêu)";

const FB_THEO_DOI: KhoiMau = {
  ten: "theo_doi",
  moTa: "Theo dõi Trang / trang cá nhân Facebook: có địa chỉ (trang_url) → mở đúng trang đó và bấm Theo dõi; ĐỂ TRỐNG → bot TỰ TÌM bài mới theo từ khoá của kịch bản và theo dõi tối đa so_nguoi TÁC GIẢ (người / Trang có nút Theo dõi trong bài; có sản phẩm/mục tiêu thì AI chấm bài liên quan trước). Đã theo dõi rồi → không bấm (bấm lần hai là bỏ theo dõi). Rủi ro cao — có duyệt; sổ cái chống làm lại; tối đa số người theo dõi mỗi ngày theo hạn mức (mặc định 10).",
  thamSo: [
    { ten: "trang_url", moTa: `địa chỉ Trang / trang cá nhân cần theo dõi (https://www.facebook.com/…) — ${MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
    TS_SO("so_nguoi", "khi để trống địa chỉ: số người / Trang tối đa sẽ theo dõi trong một lần chạy (1-5)"),
  ],
  params: { theo_doi_fb_url: { type: "string", default: "{{ts.trang_url}}", label: "Trang / trang cá nhân cần theo dõi" }, so_theo_doi_fb: { type: "number", default: "{{ts.so_nguoi}}", label: "Số người / Trang theo dõi tối đa" } },
  trangThu: "https://www.facebook.com/search/posts?q=… (nút Theo dõi trong bài — khảo sát 04/10); đầu Trang: CHƯA kiểm trên trang thật",
  yamlSteps: `  - id: dia_chi_theo_doi_fb
    template: "{{theo_doi_fb_url}}"
    into: dc_theo_doi_fb

  - id: theo_doi_trang_fb
    for_each: "ds_bai(dc_theo_doi_fb)"
    max_items: 1
    on: web
    do: "mở {{item.lien_ket}} rồi bấm Theo dõi"
    expect: "nút chuyển sang Đang theo dõi"
    risk: high
    idempotent: unsafe
    timeout: 45s
    ledger: da_theo_doi`,
  learned: {
    theo_doi_trang_fb: {
      actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }, { kind: "click", target: FB_NUT_THEO_DOI_TRANG }],
      bo_qua_khi: [{ khi: { t: "locator_visible", target: FB_DA_THEO_DOI_TRANG }, ghi: "đã theo dõi từ trước (Trang / người này) — không bấm (bấm lần hai là bỏ theo dõi)" }],
      postcondition: [{ t: "locator_visible", target: FB_DA_THEO_DOI_TRANG }],
      dem_ngay: "theo_doi",
    },
  },
  tuTim: FB_THEO_DOI_TU_TIM,
};

const X_THEO_DOI: KhoiMau = {
  ten: "theo_doi",
  moTa: "Theo dõi tài khoản X: có địa chỉ hồ sơ (tai_khoan_url) → mở hồ sơ và bấm Theo dõi; ĐỂ TRỐNG → bot TỰ TÌM bài mới nhất theo từ khoá của kịch bản và theo dõi tối đa so_nguoi TÁC GIẢ (bỏ quảng cáo, bỏ chính nick, mỗi người một lần; có sản phẩm/mục tiêu thì AI chấm bài liên quan trước). Đã theo dõi rồi → không bấm. Rủi ro cao — có duyệt; sổ cái + hạn mức theo dõi mỗi ngày (mặc định 10).",
  thamSo: [
    { ten: "tai_khoan_url", moTa: `địa chỉ hồ sơ cần theo dõi (https://x.com/<handle>) — ${MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
    TS_SO("so_nguoi", "khi để trống địa chỉ: số người tối đa sẽ theo dõi trong một lần chạy (1-5)"),
  ],
  params: { theo_doi_x_url: { type: "string", default: "{{ts.tai_khoan_url}}", label: "Hồ sơ X cần theo dõi" }, so_theo_doi_x: { type: "number", default: "{{ts.so_nguoi}}", label: "Số người theo dõi tối đa" } },
  trangThu: "https://x.com/<handle> (khảo sát trang_ca_nhan 04/10)",
  yamlSteps: `  - id: dia_chi_theo_doi_x
    template: "{{theo_doi_x_url}}"
    into: dc_theo_doi_x

  - id: theo_doi_x
    for_each: "ds_bai(dc_theo_doi_x)"
    max_items: 1
    on: web
    do: "mở hồ sơ {{item.lien_ket}} rồi bấm Theo dõi"
    expect: "nút chuyển sang Đang theo dõi"
    risk: high
    idempotent: unsafe
    timeout: 45s
    ledger: da_theo_doi`,
  learned: { theo_doi_x: X_THEO_DOI_HOC("{{item.lien_ket}}") },
  tuTim: X_THEO_DOI_TU_TIM,
};

const TT_THEO_DOI: KhoiMau = {
  ten: "theo_doi",
  moTa: "Theo dõi (Follow) tài khoản TikTok: có địa chỉ hồ sơ (tai_khoan_url) → mở hồ sơ và bấm Follow; ĐỂ TRỐNG → bot TỰ TÌM video theo từ khoá của kịch bản và theo dõi tối đa so_nguoi TÁC GIẢ (mở video, bấm dấu + trên ảnh đại diện; bỏ chính nick, mỗi người một lần; có sản phẩm/mục tiêu thì AI chấm video liên quan trước). Đã follow rồi → không bấm. Rủi ro cao — có duyệt; sổ cái + hạn mức theo dõi mỗi ngày (mặc định 10).",
  thamSo: [
    { ten: "tai_khoan_url", moTa: `địa chỉ hồ sơ cần theo dõi (https://www.tiktok.com/@<nick>) — ${MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
    TS_SO("so_nguoi", "khi để trống địa chỉ: số người tối đa sẽ theo dõi trong một lần chạy (1-5)"),
  ],
  params: { theo_doi_tt_url: { type: "string", default: "{{ts.tai_khoan_url}}", label: "Hồ sơ TikTok cần theo dõi" }, so_theo_doi_tt: { type: "number", default: "{{ts.so_nguoi}}", label: "Số người theo dõi tối đa" } },
  trangThu: "CHƯA kiểm trên trang thật (khảo sát hồ sơ TikTok 04/10 bị CAPTCHA); dấu + feed-follow đo ở /foryou",
  yamlSteps: `  - id: dia_chi_theo_doi_tt
    template: "{{theo_doi_tt_url}}"
    into: dc_theo_doi_tt

  - id: theo_doi_tt
    for_each: "ds_bai(dc_theo_doi_tt)"
    max_items: 1
    on: web
    do: "mở hồ sơ {{item.lien_ket}} rồi bấm Follow"
    expect: "nút chuyển sang Following"
    risk: high
    idempotent: unsafe
    timeout: 45s
    ledger: da_theo_doi`,
  learned: {
    theo_doi_tt: {
      actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }, { kind: "click", target: TT_NUT_FOLLOW_HO_SO }],
      bo_qua_khi: [{ khi: { t: "locator_visible", target: TT_DA_FOLLOW_HO_SO }, ghi: "đã follow tài khoản này từ trước — không bấm (bấm lần hai là bỏ follow)" }],
      postcondition: [{ t: "locator_visible", target: TT_DA_FOLLOW_HO_SO }],
      dem_ngay: "theo_doi",
    },
  },
  tuTim: TT_THEO_DOI_TU_TIM,
};

const YT_DANG_KY: KhoiMau = {
  ten: "dang_ky",
  moTa: "Đăng ký (Subscribe) kênh YouTube: có địa chỉ kênh (kenh_url) → mở kênh và bấm Đăng ký; ĐỂ TRỐNG → bot TỰ TÌM video theo từ khoá của kịch bản và đăng ký tối đa so_kenh KÊNH của các video đó (mỗi kênh một lần; có sản phẩm/mục tiêu thì AI chấm video liên quan trước). Đã đăng ký rồi → không bấm (bấm lần hai là huỷ). Rủi ro cao — có duyệt; sổ cái + hạn mức theo dõi/đăng ký mỗi ngày (mặc định 10).",
  thamSo: [
    { ten: "kenh_url", moTa: `địa chỉ kênh cần đăng ký (https://www.youtube.com/@<kênh>) — ${MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
    TS_SO("so_kenh", "khi để trống địa chỉ: số kênh tối đa sẽ đăng ký trong một lần chạy (1-5)"),
  ],
  params: { dang_ky_yt_url: { type: "string", default: "{{ts.kenh_url}}", label: "Kênh YouTube cần đăng ký" }, so_dang_ky_yt: { type: "number", default: "{{ts.so_kenh}}", label: "Số kênh đăng ký tối đa" } },
  trangThu: "https://www.youtube.com/@<kênh> (khảo sát kenh 04/10)",
  yamlSteps: `  - id: dia_chi_dang_ky_yt
    template: "{{dang_ky_yt_url}}"
    into: dc_dang_ky_yt

  - id: dang_ky_kenh_yt
    for_each: "ds_bai(dc_dang_ky_yt)"
    max_items: 1
    on: web
    do: "mở kênh {{item.lien_ket}} rồi bấm Đăng ký"
    expect: "nút chuyển sang Đã đăng ký"
    risk: high
    idempotent: unsafe
    timeout: 45s
    ledger: da_dang_ky_kenh`,
  learned: { dang_ky_kenh_yt: YT_DANG_KY_HOC("{{item.lien_ket}}") },
  tuTim: YT_DANG_KY_TU_TIM,
};

const RD_THAM_GIA: KhoiMau = {
  ten: "tham_gia_cong_dong",
  moTa: "Tham gia (Join) cộng đồng Reddit: có địa chỉ cộng đồng (cong_dong_url) → mở và bấm Join; ĐỂ TRỐNG → bot TỰ TÌM bài theo từ khoá của kịch bản và tham gia tối đa so_cong_dong CỘNG ĐỒNG của các bài đó (mỗi cộng đồng một lần; có sản phẩm/mục tiêu thì AI chấm bài liên quan trước). Đã tham gia rồi → không bấm (bấm lần hai là rời). Rủi ro cao — có duyệt; sổ cái + hạn mức theo dõi/tham gia mỗi ngày (mặc định 10). KHÔNG bỏ phiếu.",
  thamSo: [
    { ten: "cong_dong_url", moTa: `địa chỉ cộng đồng (https://www.reddit.com/r/<tên>/) — ${MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
    TS_SO("so_cong_dong", "khi để trống địa chỉ: số cộng đồng tối đa sẽ tham gia trong một lần chạy (1-3)", 3),
  ],
  params: { cong_dong_rd_url: { type: "string", default: "{{ts.cong_dong_url}}", label: "Cộng đồng Reddit cần tham gia" }, so_cong_dong_rd: { type: "number", default: "{{ts.so_cong_dong}}", label: "Số cộng đồng tham gia tối đa" } },
  trangThu: "https://www.reddit.com/r/<tên>/ (khảo sát cong_dong 04/10)",
  yamlSteps: `  - id: dia_chi_cong_dong_rd
    template: "{{cong_dong_rd_url}}"
    into: dc_cong_dong_rd

  - id: tham_gia_cong_dong_rd
    for_each: "ds_bai(dc_cong_dong_rd)"
    max_items: 1
    on: web
    do: "mở cộng đồng {{item.lien_ket}} rồi bấm Join"
    expect: "nút chuyển sang Joined"
    risk: high
    idempotent: unsafe
    timeout: 45s
    ledger: da_tham_gia_cong_dong`,
  learned: { tham_gia_cong_dong_rd: RD_JOIN_HOC("{{item.lien_ket}}") },
  tuTim: RD_CONG_DONG_TU_TIM,
};

const FB_CHIA_SE: KhoiMau = {
  ten: "chia_se_bai",
  moTa: "Chia sẻ MỘT bài Facebook lên trang cá nhân của nick (nút Chia sẻ → 'Chia sẻ ngay'; KHÔNG gửi qua Messenger): có địa chỉ (bai_url) → đúng bài đó; ĐỂ TRỐNG → bot TỰ TÌM một bài theo từ khoá của kịch bản (bỏ bài quá ngắn / quảng cáo / đã chia sẻ; có sản phẩm/mục tiêu thì AI chấm liên quan). loi_chia_se = co → AI đọc bài rồi soạn một câu giới thiệu (theo góc nhìn) gõ kèm khi chia sẻ; khong (mặc định) → chỉ chia sẻ. Rủi ro cao — có duyệt; sổ cái + hạn mức chia sẻ mỗi ngày (mặc định 5).",
  thamSo: [
    { ten: "bai_url", moTa: `địa chỉ bài cần chia sẻ — ${MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
    { ten: "loi_chia_se", moTa: "co = AI soạn một câu giới thiệu gõ kèm khi chia sẻ; khong = chỉ chia sẻ (mặc định)", kieu: "chuoi", macDinh: "khong", luaChon: ["co", "khong"] },
    { ten: "goc_nhin", moTa: "góc nhìn của lời chia sẻ (khi loi_chia_se = co), ví dụ: người mới học / đã dùng lâu", kieu: "chuoi", batBuoc: false },
  ],
  params: {
    chia_se_fb_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài cần chia sẻ" },
    kem_loi_chia_se_fb: { type: "string", default: "{{ts.loi_chia_se}}", label: "Kèm lời chia sẻ AI soạn (co / khong)" },
    goc_nhin_chia_se_fb: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của lời chia sẻ" },
  },
  trangThu: "https://www.facebook.com/search/posts?q=… (hộp Chia sẻ — khảo sát menu_chia_se 04/10)",
  yamlSteps: `  - id: dat_noi_dung_chia_se_fb
    template: "{{ '' }}"
    into: noi_dung_chia_se_fb

  - id: dia_chi_chia_se_fb
    template: "{{chia_se_fb_url}}"
    into: dc_chia_se_fb

  - id: mo_bai_chia_se_fb
    when: "kem_loi_chia_se_fb == 'co'"
    on: web
    do: "mở bài {{chia_se_fb_url}} để đọc trước khi soạn lời chia sẻ"

  - id: doc_bai_chia_se_fb
    when: "kem_loi_chia_se_fb == 'co'"
    on: web
    extract: "nội dung bài đang mở (để soạn lời chia sẻ)"
    into: noi_dung_chia_se_fb
    optional: true
    timeout: 10s

  - id: soan_loi_chia_se_fb
    when: "kem_loi_chia_se_fb == 'co'"
    generate:
      input: "${SOAN_LOI_CS("{{ str(noi_dung_chia_se_fb) }}")}"
      guide: knowledge
      max_words: 30
    into: loi_chia_se_fb

  - id: chia_se_bai_fb
    for_each: "ds_bai(dc_chia_se_fb)"
    max_items: 1
    when: "kem_loi_chia_se_fb != 'co'"
    on: web
    do: "mở bài {{item.lien_ket}}, bấm Chia sẻ rồi bấm Chia sẻ ngay (lên trang cá nhân)"
    expect: "hộp Chia sẻ đóng lại"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_chia_se

  - id: chia_se_bai_loi_fb
    for_each: "ds_bai(dc_chia_se_fb)"
    max_items: 1
    when: "kem_loi_chia_se_fb == 'co'"
    on: web
    do: "mở bài {{item.lien_ket}}, bấm Chia sẻ, gõ {{loi_chia_se_fb}} rồi bấm Chia sẻ ngay"
    expect: "hộp Chia sẻ đóng lại"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_chia_se`,
  learned: {
    mo_bai_chia_se_fb: { actions: [{ kind: "navigate", url: "{{chia_se_fb_url}}" }] },
    doc_bai_chia_se_fb: { extract_spec: { mode: "single", attr: "text", target: { describe: "nội dung bài đang mở (để soạn lời chia sẻ)", vung: "bai_dich", ladder: [
      { t: "xpath", xpath: '(//*[@data-ad-rendering-role="story_message"])[1]' },
      { t: "xpath", xpath: '(//*[@data-ad-comet-preview="message"])[1]' },
    ] } } },
    soan_loi_chia_se_fb: { dung_neu_sai: [{ dk: "len(trim(str(loi_chia_se_fb))) > 0", ly_do: "AI chưa soạn được lời chia sẻ — không chia sẻ (đổi loi_chia_se = khong để chỉ chia sẻ)" }] },
    chia_se_bai_fb: { actions: FB_CHIA_SE_ACTIONS(false), postcondition: FB_HOP_CHIA_SE_DONG, dem_ngay: "chia_se" },
    chia_se_bai_loi_fb: { actions: FB_CHIA_SE_ACTIONS(false, "{{loi_chia_se_fb}}"), postcondition: [...FB_HOP_CHIA_SE_DONG, { t: "text_visible", text: "{{loi_chia_se_fb}}" }], dem_ngay: "chia_se" },
  },
  tuTim: FB_CHIA_SE_TU_TIM,
};

const TT_DANG_LAI: KhoiMau = {
  ten: "dang_lai",
  moTa: "Đăng lại (Repost) MỘT video TikTok: có địa chỉ (bai_url) → đúng video đó; ĐỂ TRỐNG → bot TỰ TÌM một video theo từ khoá của kịch bản (bỏ video của chính nick, video đã đăng lại; có sản phẩm/mục tiêu thì AI chấm liên quan). Bấm Chia sẻ → Repost, chốt đúng mã video trước khi bấm (trang tự chuyển video thì không bấm). Rủi ro cao — có duyệt; sổ cái + hạn mức chia sẻ/đăng lại mỗi ngày (mặc định 5).",
  thamSo: [{ ten: "bai_url", moTa: `địa chỉ video cần đăng lại (https://www.tiktok.com/@<nick>/video/<số>) — ${MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false }],
  params: { dang_lai_tt_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video cần đăng lại" } },
  trangThu: "CHƯA kiểm trên trang thật: mục Repost; nút share-icon đo ở /foryou 04/10",
  yamlSteps: `  - id: dia_chi_dang_lai_tt
    template: "{{dang_lai_tt_url}}"
    into: dc_dang_lai_tt

  - id: dang_lai_tt
    for_each: "ds_bai(dc_dang_lai_tt)"
    max_items: 1
    on: web
    do: "mở video {{item.lien_ket}}, bấm Chia sẻ rồi chọn Repost"
    expect: "video chuyển sang đã đăng lại"
    risk: high
    idempotent: unsafe
    timeout: 45s
    ledger: da_dang_lai_tt`,
  learned: { dang_lai_tt: { actions: TT_REPOST_ACTIONS, postcondition: [{ t: "url_contains", s: "{{ ma_video(item.lien_ket) }}" }, ...TT_DA_REPOST], dem_ngay: "chia_se" } },
  tuTim: TT_DANG_LAI_TU_TIM,
};

/** Khối nhóm 1 theo mạng — nối vào thư viện ở src/shared/khoi-thu-vien.ts. */
export const KHOI_THEO_DOI: Readonly<Record<"facebook" | "x" | "tiktok" | "youtube" | "reddit", KhoiMau[]>> = {
  facebook: [FB_THEO_DOI, FB_CHIA_SE],
  x: [X_THEO_DOI],
  tiktok: [TT_THEO_DOI, TT_DANG_LAI],
  youtube: [YT_DANG_KY],
  reddit: [RD_THAM_GIA],
};

/** Hiển thị trong bản đồ (khoá "<mạng>/<thao tác>" như HIEN_THI của ban-do.ts). */
export const HIEN_THI_THEO_DOI: Readonly<Record<string, { bieuTuong: string; tenNgan: string; mauMoTa: string }>> = {
  "facebook/theo_doi": { bieuTuong: "➕", tenNgan: "Theo dõi Trang / người", mauMoTa: "[Mở {trang_url} và bấm Theo dõi][!trang_url Tự tìm bài mới theo từ khoá và theo dõi tối đa {so_nguoi} tác giả (người / Trang) chưa theo dõi] — đã theo dõi thì bỏ qua" },
  "x/theo_doi": { bieuTuong: "➕", tenNgan: "Theo dõi tài khoản", mauMoTa: "[Mở hồ sơ {tai_khoan_url} và bấm Theo dõi][!tai_khoan_url Tự tìm bài mới nhất theo từ khoá và theo dõi tối đa {so_nguoi} tác giả chưa theo dõi (bỏ quảng cáo, bỏ chính mình)]" },
  "tiktok/theo_doi": { bieuTuong: "➕", tenNgan: "Theo dõi tài khoản", mauMoTa: "[Mở hồ sơ {tai_khoan_url} và bấm Follow][!tai_khoan_url Tự tìm video theo từ khoá và theo dõi tối đa {so_nguoi} tác giả chưa theo dõi]" },
  "youtube/dang_ky": { bieuTuong: "🔔", tenNgan: "Đăng ký kênh", mauMoTa: "[Mở kênh {kenh_url} và bấm Đăng ký][!kenh_url Tự tìm video theo từ khoá và đăng ký tối đa {so_kenh} kênh chưa đăng ký]" },
  "reddit/tham_gia_cong_dong": { bieuTuong: "🤝", tenNgan: "Tham gia cộng đồng", mauMoTa: "[Mở cộng đồng {cong_dong_url} và bấm Join][!cong_dong_url Tự tìm bài theo từ khoá và tham gia tối đa {so_cong_dong} cộng đồng của các bài đó]" },
  "facebook/chia_se_bai": { bieuTuong: "🔁", tenNgan: "Chia sẻ bài lên trang cá nhân", mauMoTa: "[Mở bài {bai_url}][!bai_url Tự tìm một bài theo từ khoá] và chia sẻ lên trang cá nhân[ — kèm lời AI soạn: {loi_chia_se}][ (góc nhìn “{goc_nhin}”)]" },
  "tiktok/dang_lai": { bieuTuong: "🔁", tenNgan: "Đăng lại (Repost) video", mauMoTa: "[Mở video {bai_url}][!bai_url Tự tìm một video theo từ khoá] và bấm Chia sẻ → Repost" },
};
/** Nhãn ngắn của tham số mới (NHAN của ban-do.ts). */
export const NHAN_THEO_DOI: Readonly<Record<string, string>> = {
  trang_url: "Trang / trang cá nhân cần theo dõi",
  tai_khoan_url: "Hồ sơ cần theo dõi",
  kenh_url: "Kênh cần đăng ký",
  cong_dong_url: "Cộng đồng Reddit (r/…)",
  so_nguoi: "Số người theo dõi tối đa",
  so_kenh: "Số kênh đăng ký tối đa",
  so_cong_dong: "Số cộng đồng tham gia tối đa",
  loi_chia_se: "Kèm lời chia sẻ AI soạn (co / khong)",
};
